import { useEffect } from "react";
import { useMap } from "react-leaflet";

/** Share one zoom scale across marker icons, including their badges and arrows. */
export default function ViewportMapMarkerScale() {
  const map = useMap();

  useEffect(() => {
    const container = map.getContainer();
    const updateScale = () => {
      const minZoom = map.getMinZoom();
      const maxZoom = map.getMaxZoom();
      // The environment's zoom limit can arrive after the map is mounted.
      const zoomRange =
        Number.isFinite(maxZoom) && maxZoom > minZoom ? maxZoom - minZoom : 4;
      const progress = Math.max(
        0,
        Math.min(1, (map.getZoom() - minZoom) / zoomRange)
      );
      container.style.setProperty(
        "--map-marker-scale",
        String(0.5 + progress * 0.5)
      );
    };

    updateScale();
    map.on("zoom zoomlevelschange", updateScale);
    return () => {
      map.off("zoom zoomlevelschange", updateScale);
      container.style.removeProperty("--map-marker-scale");
    };
  }, [map]);

  return null;
}
